<template>
  <StandardButton
    v-bind="buttonProps"
    @click="onButtonClick"
  >
    <template
      v-if="buttonProps.icon"
      #icon
    >
      <slot name="icon" />
    </template>
  </StandardButton>
  <PVConfirmPopup
    @click.stop
    @mousedown.stop
  />
</template>
<script lang="ts">
export default {
  name: 'StandardButtonWithConfirmPopup',
  compatConfig: { MODE: 3 },
};
</script>
<script setup lang="ts">
import type { StandardButtonProps } from '@/types/StandardButtonTypes';
// oxlint-disable-next-line no-restricted-imports
import { useConfirm } from 'primevue/useconfirm';

const props = defineProps<{
  buttonProps: StandardButtonProps;
  confirmProps: Parameters<ReturnType<typeof useConfirm>['require']>[0];
}>();

const confirm = useConfirm();

const onButtonClick = (event: MouseEvent) => {
  if (event.currentTarget instanceof HTMLElement) {
    confirm.require({
      target: event.currentTarget ?? undefined,
      message: props.confirmProps.message,
      icon: props.confirmProps.icon,
      rejectProps: props.confirmProps.rejectProps,
      acceptProps: props.confirmProps.acceptProps,
      accept: props.confirmProps.accept,
      reject: props.confirmProps.reject,
    });
  }
};
</script>
